<script setup>
import { TabsList } from "reka-ui";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  loop: { type: Boolean, default: undefined },
  class: { type: String, default: undefined },
});
</script>

<template>
  <TabsList
    data-slot="tabs-list"
    :loop="props.loop"
    :class="
      cn(
        'bg-muted text-muted-foreground inline-flex h-9 w-fit items-center justify-center rounded-lg p-[3px]',
        props.class
      )
    "
  >
    <slot />
  </TabsList>
</template>
